// export const baseUrl = 'https://parcel.renault-belarus.by';
export const mode = 'prod';
// @ts-ignore
export const baseUrl = mode === 'prod' ? 'https://mitsubishi.by' : 'http://localhost:3000';